/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from "react";
import {SurveyFormInputText} from "../SurveyFormInputText";
import {SurveyFormInputBoolean} from "../SurveyFormInputBoolean";
import {PermitSurveySection} from "../../../../Pages/ConservationActions/PermitSurveySection";
import {SurveyFormComposedInput} from "../SurveyFormComposedInput";

export const SurveyFormBooleanWithPermitInput = (props) => {
    
    // Validation is shown in this parent 
    const {Validation, ...propsWithoutValidation } = props;
    
    let { ConservationAction, Question, Answer = {}} = props;
    
    let permitValidation = null;
    let ourConservationActionPermits = ConservationAction?.ConservationActionPermits?.filter?.((x) => x.Permit?.permitTypeId === Question.permitTypeId) ?? [];
    
    const { valueBool = null } = (Answer ?? {});
    if (ourConservationActionPermits.length > 0 && valueBool !== 1) {
        permitValidation = "This answer should be 'Yes' since this Conservation Action has one or more of the specified permit type assigned."
    }
    
    const showPermit = (valueBool === 1 || ourConservationActionPermits.length > 0)
    const showNotes = valueBool !== 1 && valueBool !== null;
    
    //return composed input based on the conditional logic above.
    return <SurveyFormComposedInput
        Validation={permitValidation ?? Validation}
    >
        <span>Is this permit needed?</span>
        <SurveyFormInputBoolean
            {...props}
            Validation={null}
        />
        {
            showPermit ? <PermitSurveySection
                {...props}
                Validation={null}
            /> : null
        }
        {
            showNotes ? 
            <Fragment>
                <span>Why?</span>
                <SurveyFormInputText {...props} Validation={null}/>
            </Fragment>
            : null
        }
    </SurveyFormComposedInput>;
};
